import { TimeCharter } from "../../search-vessels/models/search.interfaces";
import { SearchIcon } from "../../shared/Icons";
import { themeAtom } from "../../shared/atoms";
import { VesselDetails } from "../models/home.interfaces";
import { MyVesselsTableRow } from "./MyVesselsTableRow";
import { useAtomValue } from "jotai";
import { Link } from "react-router-dom";
import { twMerge } from "tailwind-merge";

type MyVesselsTableRowProps = {
  data: VesselDetails[] | null;
  openIndex: number | null;
  toggleAccordion: (index: number, item: VesselDetails) => Promise<void>;
  formatDate: (dateString: string) => string;
  removeUser: (event: React.MouseEvent<HTMLSpanElement>, index: number, item: VesselDetails) => Promise<void>;
  timeCharters: TimeCharter[];
};

const Th = ({ children, className = "" }: { children?: React.ReactNode; className?: string }) => {
  return <th className={twMerge(`h-14 px-4 py-2 text-[13px] font-semibold ${className}`)}>{children}</th>;
};

export function MyVesselsTable({
  data,
  openIndex,
  toggleAccordion,
  formatDate,
  removeUser,
  timeCharters,
}: MyVesselsTableRowProps) {
  const theme = useAtomValue(themeAtom);
  return (
    <table className={twMerge("w-full border", theme.myVesselsTable.tailwind.tableBorder)}>
      <thead className="sticky">
        <tr className={twMerge("text-left text-sm", theme.myVesselsTable.tailwind.textDefault)}>
          <Th>VESSEL NAME</Th>
          <Th>CP DATE</Th>
          <Th>IMO NUMBER</Th>
          <Th>VESSEL TYPE</Th>
          <Th>VESSEL OWNER</Th>
          <Th>DWT</Th>
          <Th>SAFETY RATING</Th>
          <Th>GHG RATING</Th>
          <Th />
        </tr>
      </thead>
      <tbody>
        {(() => {
          if (!data) {
            return (
              <tr className="h-96">
                <td colSpan={100} />
              </tr>
            );
          }
          if (data.length === 0) {
            return (
              <tr className="h-96">
                <td
                  colSpan={100}
                  className={twMerge("text-center text-base", theme.myVesselsTable.tailwind.textDefault)}
                >
                  <div className="flex h-full min-h-[200px] flex-col items-center justify-center gap-2">
                    <p
                      className={twMerge(
                        "w-18 h-18 rounded-full p-7",
                        theme.myVesselsTable.tailwind.emptyStateIconBg,
                        theme.myVesselsTable.tailwind.emptyStateText,
                      )}
                      aria-hidden="true"
                    >
                      <SearchIcon className="h-10 w-10" color={theme.myVesselsTable.searchIcon.iconColor} />
                    </p>
                    <p>
                      Go to the{" "}
                      <Link to="/vessels" className={theme.myVesselsTable.tailwind.linkText}>
                        vessel page
                      </Link>{" "}
                      to select a vessel you would like to monitor
                    </p>
                  </div>
                </td>
              </tr>
            );
          }

          return data.map((item, index) => (
            <MyVesselsTableRow
              index={index}
              key={index}
              item={item}
              isOpen={index === openIndex}
              toggleAccordion={() => toggleAccordion(index, item)}
              formatDate={formatDate}
              removeUser={removeUser}
              timeCharters={timeCharters}
            />
          ));
        })()}
      </tbody>
    </table>
  );
}
